import { RecurringPaymentDetailsDto } from "../../../models/dtos/recurring-payment-details.dto";
import { now, oneYearInMs } from "../../utils/time.utils";

export const mockRecurringPayment: RecurringPaymentDetailsDto = {
  row_id: '1',
  status: 0,
  amount_fixed: '1200.00',
  billing_type: 1,
  billing_start_date: new Date(now - oneYearInMs * 4).toISOString(),
  billing_expire_date: new Date(now + oneYearInMs * 16).toISOString(),
  billing_period: 'monthly',
  account_number: '****1234',
  aba_number: '987654321',
};
